// extracted by mini-css-extract-plugin
export var indeterminate = "_5a-5";
export var md = "_5a-4";
export var semantic = "_5a-6";
export var sm = "_5a-3";
export var text = "_5a-7";
export var toggleInput = "_5a-0";
export var toggleSwitch = "_5a-1";
export var xs = "_5a-2";